
/* injects from baggage-loader */

'use strict';

import AddDocumentByUrlModalController from './adddocumentbyurlmodal.controller';
import AddDocumentByUrlModalTemplate from './adddocumentbyurlmodal.html';

export default class AddDocumentByUrlModalComponent {
		constructor() {
				this.templateUrl = AddDocumentByUrlModalTemplate;
				this.controller = AddDocumentByUrlModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}
